import React from 'react';
import { Input, Button, Form, Select } from 'antd';
import 'pages/dashboard/user/changeProfileUser.css';
import { useNavigate } from 'react-router-dom';
import { useGetUserProfileApi, useUpdateUserApi } from './useUserApi';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

interface dataForm {
  username: string;
  phone: string;
  date_of_birth: string;
  address: string;
}

const ChangeProfileUser: React.FC = () => {
  const [form] = Form.useForm();
  const { Option } = Select;
  let navigate = useNavigate();
  const { update } = useUpdateUserApi();
  const { profileObject } = useGetUserProfileApi();
  const { t } = useTranslation();

  const onUpdateUser = (values: any) => {
    const dataForm: dataForm = {
      username: values.username,
      phone: values.phone,
      date_of_birth:
        values.birthyear + '-' + values.birthmonth + '-' + values.birthday,
      address: values.address
    };
    update(dataForm);
  };

  const getDateOfBirth = (date: string, part: string) => {
    // 2006-10-25
    if (!date || date.length !== 10) {
      return;
    }
    switch (part) {
      case 'day':
        return date.slice(8, 10);
      case 'month':
        return date.slice(5, 7);
      case 'year':
        return date.slice(0, 4);
    }
  };

  return (
    <div className="redeem-code">
      <Helmet>
        <title>Profile Update - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App user profile update for web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>
      <h2>{t('profile.update_profile')}</h2>
      <div className="form-edit">
        {profileObject && (
          <Form
            wrapperCol={{ span: 24 }}
            labelCol={{ span: 8 }}
            layout="horizontal"
            form={form}
            initialValues={{
              layout: 'horizontal',
              username: profileObject?.data?.username,
              phone: profileObject?.data?.phone,
              address: profileObject?.data?.address,
              birthday: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'day'
              ),
              birthmonth: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'month'
              ),
              birthyear: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'year'
              )
            }}
            onFinish={onUpdateUser}
          >
            <Form.Item label={t('profile.user_name')} name="username">
              <Input
                style={{ height: '50px' }}
                placeholder={t('profile.full_name')}
              />
            </Form.Item>

            <Form.Item
              label={t('profile.phone_number')}
              name="phone"
              rules={[
                {
                  pattern: new RegExp(
                    /^((\+)|0)+([0-9]{9,11})$/
                  ),
                  message: '請輸入一個有效的電話號碼'
                }
              ]}
            >
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder=""
              />
            </Form.Item>

            <Form.Item label={t('profile.date_of_birth')}>
              <div className="date-of-birth">
                <Form.Item
                  className="birthday-day"
                  name="birthday"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/0[0-9]|1[0-9]|2[0-9]|3[0-1]/),
                      message: '出生日期無效'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    name="BirthDay"
                    type="text"
                    placeholder="01"
                    maxLength={2}
                  />
                </Form.Item>
                <Form.Item 
                  name="birthmonth" 
                  className="birthday-month" 
                  rules={[
                    {
                      required: true,
                      message: '出生月份無效'
                    }
                  ]}>
                  <Select size="large" style={{ height: '50px' }}>
                    <Option value="01">Januari</Option>
                    <Option value="02">Februari</Option>
                    <Option value="03">Berbaris</Option>
                    <Option value="04">April</Option>
                    <Option value="05">Mungkin</Option>
                    <Option value="06">Juni</Option>
                    <Option value="07">Juli</Option>
                    <Option value="08">Agustus</Option>
                    <Option value="09">September</Option>
                    <Option value="10">Oktober</Option>
                    <Option value="11">November</Option>
                    <Option value="12">Desember</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  className="birthday-year"
                  name="birthyear"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^(19|20)\d{2}$/),
                      message: '出生年份無效'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    id="BirthDayYear"
                    type="text"
                    placeholder="1997"
                    maxLength={4}
                  ></Input>
                </Form.Item>
              </div>
            </Form.Item>

            <Form.Item label={t('profile.address')} name="address">
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder="Address"
              />
            </Form.Item>
            <div className="form-footer">
              <Button
                type="primary"
                htmlType="button"
                className="form-btn btn_cancle"
                onClick={() => navigate('/')}
              >
                {t('profile.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="form-btn btn_submit"
                // loading={isLoading}
              >
                {t('profile.save_profile')}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ChangeProfileUser;
